module.exports = __webpack_public_path__ + "img/Finished.39657ab9.png";